import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { Anchor } from 'brand-guidelines/Anchor';
import { LinkButton } from 'brand-guidelines/Buttons-styled-components';
import { Modal } from 'common/components/Modal/Modal';
import { ModalHeader, ModalTitle } from 'common/components/Modal/Modal-styled-components';

import { selectDataClinic } from 'connect/selectors';

import { useRedirectFindNewDentist } from 'services/redirection/use-redirect-find-new-dentist';

import { BookingRestrictedModalBody, BookingRestrictedModalText } from './BookingRestrictedModal-styled-components';

/**
 * Self-contained modal that displays when a clinic restricts new bookings from this patient.
 *
 * Simply include the component on a page that should be blocked and it will automatically display if needed.
 */
export const BookingRestrictedModal = () => {
  const clinic = useSelector(selectDataClinic);
  const showBookingRestrictedModal = useMemo(
    () => clinic.isNewBookingAllowed === false,
    [clinic.isNewBookingAllowed],
  );

  const redirectFindNewDentist = useRedirectFindNewDentist();

  return (
    <Modal
      showCloseButton={false}
      maskClosable={false}
      keyboard={false}
      visible={showBookingRestrictedModal}
      onClose={() => {}}
    >
      <BookingRestrictedModalBody>
        <ModalHeader>
          <ModalTitle>
            Booking Restricted
          </ModalTitle>
        </ModalHeader>

        <BookingRestrictedModalText>
          This practice isn't accepting new requests from patients with a previously canceled appointment.
        </BookingRestrictedModalText>
        <BookingRestrictedModalText>
          You can still{' '}
          <LinkButton onClick={redirectFindNewDentist}>book with other dentists on Opencare</LinkButton>.
        </BookingRestrictedModalText>
        <BookingRestrictedModalText>
          Questions? Contact <Anchor href="mailto:support@opencare.com" target="_blank">support@opencare.com</Anchor>.
        </BookingRestrictedModalText>
      </BookingRestrictedModalBody>
    </Modal>
  );
};
